import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../../../assets/css/auth/sign-up-complete.scss';
import CommonTitle from '../../../components/common-title/CommonTitle';

function SignupComplete() {
  const navigate = useNavigate();
  const location = useLocation();
  const userData = location.state?.userData || {};
  const message = location.state?.message || '회원가입이 성공적으로 완료되었습니다.';

  const handleLogin = () => {
    navigate('/login');
  };

  return (
    <div className="signup-complete-component">
      {/* Desktop Layout */}
      <div className="signup-complete-pc-page">
        <main className="signup-complete-section" style={{
          backgroundImage: 'url("/images1/fe8abcfd1543ad4d14edd25847908cdd87ecd720.png")',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'top center',
          backgroundSize: '100% auto'
        }}>
          <div className="container">
            {/* Page Title */}
            <CommonTitle heading="회원가입" />
           

            {/* Progress Steps */}
            <nav className="signup-steps">
              <a href="#" className="step completed">약관동의</a>
              <a href="#" className="step completed">정보 입력</a>
              <a href="#" className="step active">가입 완료</a>
            </nav>

            {/* Completion Box */}
            <div className="completion-wrapper">
              <div className="completion-box">
                <h2 className="completion-title">회원가입이 완료되었습니다.</h2>
                
                <div className="completion-message">
                  <p>회원가입을 진심으로 축하합니다.</p>
                  <p>감동과 행복을 만들어 가는 공간, 추억을 간직하는 장소</p>
                  <p>강화파라다이스에서 추모의 정을 영원히 이어 나가실 수 있기를 바랍니다.</p>
                </div>

                <button 
                  type="button" 
                  className="login-button"
                  onClick={handleLogin}
                >
                  로그인
                </button>
              </div>
            </div>
          </div>
        </main>
      </div>

      {/* Mobile Layout */}
      <div className="signup-complete">
        <div className="complete-message">
          <div className="main">회원가입이 완료되었습니다.</div>
          <div className="sub">
            <span className="highlight">회원가입을 진심으로 축하합니다.</span>
            <br />
            감동과 행복을 만들어 가는 공간,<br />
            추억을 간직하는 장소<br />
            강화파라다이스에서 추모의 정을<br />
            영원히 이어 나가실 수 있기를 바랍니다.
          </div>
          <button className="login-btn" onClick={handleLogin}>로그인</button>
        </div>
      </div>
    </div>
  );
}

export default SignupComplete;
